import { useIntl } from '@weenat/wintl'
import ListEmpty from 'app/src/kit/ListEmpty'
import { useBackgroundMapContext } from './contexts/BackgroundMapContext'

interface NoSummariesMatchingSearchTermContentProps {
  /** Override the search term. Falls back to the map context's search value when omitted. */
  searchTerm?: string
}

const NoSummariesMatchingSearchTermContent: FC<NoSummariesMatchingSearchTermContentProps> = ({
  searchTerm: searchTermProp
}) => {
  const { t } = useIntl()
  const { search } = useBackgroundMapContext()
  const searchTerm = searchTermProp ?? search

  return (
    <ListEmpty
      message={t('map.no_summaries_matching_search_term', {
        searchTerm
      })}
    />
  )
}

export default NoSummariesMatchingSearchTermContent
